/**
 * Created by orion on 7/1/17.
 */


function add_back_url(url) {
    if (!url) {
        return; // prevent interpolation errors
    }
    let full_path = document.location.href.substr(document.location.href.indexOf(document.location.pathname) + 1);
    let separator = '#!/';
    if (url.indexOf(separator) != -1) {
        let query_symbol = '?';
        if (url.split(separator)[1].indexOf('?') != -1) {
            query_symbol = '&';
        }
        return `${url}${query_symbol}from=/${escape(encodeURIComponent(full_path))}`;
    } else {
        return `${url}#!/?from=/${escape(encodeURIComponent(full_path))}`;
    }

}

/**
 * Rewrites the query of `path` so that each key of `params` is present exactly once, with
 * the given value. Everything else - the path, the other query parameters, the hash - is
 * kept as it stands, byte for byte.
 */
function withQueryParams(path, params) {
    const hashAt = path.indexOf('#');
    const hash = hashAt === -1 ? '' : path.slice(hashAt);
    const beforeHash = hashAt === -1 ? path : path.slice(0, hashAt);

    const queryAt = beforeHash.indexOf('?');
    const base = queryAt === -1 ? beforeHash : beforeHash.slice(0, queryAt);
    const pairs = queryAt === -1 ? [] : beforeHash.slice(queryAt + 1).split('&').filter(Boolean);

    const keys = Object.keys(params);
    const kept = pairs.filter(pair => !keys.includes(pair.split('=')[0]));
    const added = keys.map(k => `${k}=${encodeURIComponent(params[k])}`);
    const query = [...kept, ...added].join('&');

    return `${base}${query ? '?' + query : ''}${hash}`;
}

function backHrefQuery(url, additionalParams = undefined) {
    if (!url) {
        return url; // prevent interpolation errors
    }
    let full_path = document.location.href.substr(document.location.href.indexOf(document.location.pathname) + 1);
    let query_symbol = '?';
    if (url.indexOf('?') != -1) {
        query_symbol = '&';
    }
    if (additionalParams) {
        full_path = withQueryParams(full_path, additionalParams);
    }
    let result = `${url}${query_symbol}from=/${escape(encodeURIComponent(full_path))}`;

    return result;
}

function decodeBackUrl(url) {
    return decodeURIComponent(unescape(url));
}

export {add_back_url, add_back_url as abu, backHrefQuery, decodeBackUrl};
